// Nothin But Juice - Theme JS
document.addEventListener('DOMContentLoaded', function() {
  // Mobile nav burger toggle
  const burger = document.querySelector('.nav-burger');
  const navLinks = document.querySelector('.nav-links');
  if (burger && navLinks) {
    burger.addEventListener('click', function() {
      navLinks.classList.toggle('open');
    });
  }
});
